import { render, staticRenderFns } from "./OrderView.vue?vue&type=template&id=16da546a&scoped=true"
import script from "./OrderView.vue?vue&type=script&lang=js"
export * from "./OrderView.vue?vue&type=script&lang=js"
import style0 from "./OrderView.vue?vue&type=style&index=0&id=16da546a&prod&lang=scss&scoped=true"
import style1 from "./OrderView.vue?vue&type=style&index=1&id=16da546a&prod&lang=scss"
import style2 from "./OrderView.vue?vue&type=style&index=2&id=16da546a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16da546a",
  null
  
)

export default component.exports